module.exports = __webpack_public_path__ + "img/9dd1264.svg";